import { useEffect } from "react";
import Lenis from "lenis";
import Hero from "@/components/Hero";
import Services from "@/components/Services";
import BrandMarquee from "@/components/Marquee";
import Contact from "@/components/Contact";
import CustomCursor from "@/components/CustomCursor";

export default function Landing() {
  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.2,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
    });
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  return (
    <main data-testid="landing-page" className="grain relative bg-black text-[#F5F2EB]">
      <CustomCursor />
      <Hero />
      <BrandMarquee />
      <Services />
      <Contact />
    </main>
  );
}
